import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const DeleteShippingCostDialog = ({ deleteAsk, onCancel, onConfirm }) => (
    <Dialog open={Boolean(deleteAsk)} onClose={onCancel} PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle>Versandkosten löschen?</DialogTitle>
        <DialogContent dividers>
            <Typography>
                Möchtest du "{deleteAsk?.shippingCost?.name}" wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht
                werden.
            </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
            <Button onClick={onCancel}>Abbrechen</Button>
            <Button color="error" onClick={onConfirm}>
                Löschen
            </Button>
        </DialogActions>
    </Dialog>
);

export default DeleteShippingCostDialog;
